<div class="spinner-container mb-3 flex-row justify-center items-center" *ngIf="isLoading$ | async; else jl_edit">
    <mat-progress-spinner color="accent" mode="indeterminate" diameter="30" class="self-center">
    </mat-progress-spinner>
  </div>
  <ng-template #jl_edit>
    <ng-container *ngIf="data">
<div>
    <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label">Previous Charge Experience:</strong>
        <span flex class="flex-60" data-qa-id="an_rjd_previousChargeExperience_readonly">
          <nova-job-qualifications-required-type-change [change]="data.previousChargeExpRequiredTypeId"></nova-job-qualifications-required-type-change>
        </span>
    </div>

    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label">Years of Experience:</strong>
      <div flex class="flex-60" data-qa-id="an_rjd_yearOfExperience_readonly">
        <nova-job-qualifications-years-of-exp-change [change]="data.yearsOfExp" [noteChange]="data.yearsOfExpNote"></nova-job-qualifications-years-of-exp-change>
      </div>
    </div>

    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label">Patient Ratio Experience:</strong>
      <span
        flex
        class="flex-60"
        data-qa-id="an_rjd_patientRatioExperience_readonly"
      >
        <nova-job-qualifications-patient-ratio-change [change]="data.patientRatioExp"></nova-job-qualifications-patient-ratio-change>
    </span>
    </div>


    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label">Charting System:</strong>
      <span
        flex
        class="flex-60"
        data-qa-id="an_rjd_chartingSystemName_readonly"
      >
        <nova-job-qualifications-charting-system-change [change]="data.chartingRequiredTypeAndSystemName"></nova-job-qualifications-charting-system-change>
      </span>
    </div>

    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label"
        >Teaching Hospital Experience:</strong
      >
      <span
        flex
        class="flex-60"
        data-qa-id="an_rjd_teachingHospitalExperience_readonly"
        >
          <nova-job-qualifications-required-type-change [change]="data.teachingHospExpRequiredTypeId"></nova-job-qualifications-required-type-change>
        </span
      >
    </div>

    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label"
        >Community Hospital Experience:</strong
      >
      <span
        flex
        class="flex-60"
        data-qa-id="an_rjd_communityHospitalExperience_readonly"
        >
          <nova-job-qualifications-required-type-change [change]="data.communityHospExpRequiredTypeId"></nova-job-qualifications-required-type-change>
        </span
      >
    </div>

    <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label"
          >LTAC Experience:</strong
        >
        <span
          flex
          class="flex-60"
          data-qa-id="an_rjd_ltacExperience_readonly"
          >
            <nova-job-qualifications-required-type-change [change]="data.ltacExpRequiredTypeId"></nova-job-qualifications-required-type-change>
          </span
        >
      </div>

    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label">Trauma Level I Experience:</strong>
      <span
        flex
        class="flex-60"
        data-qa-id="an_rjd_traumaLevelIExperience_readonly"
        >
          <nova-job-qualifications-required-type-change [change]="data.traumaLevelIExpRequiredTypeId"></nova-job-qualifications-required-type-change>
        </span
      >
    </div>

    <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label">Trauma Level II Experience:</strong>
        <span
          flex
          class="flex-60"
          data-qa-id="an_rjd_traumaLevelIExperience_readonly"
          >
            <nova-job-qualifications-required-type-change [change]="data.traumaLevelIIExpRequiredTypeId"></nova-job-qualifications-required-type-change>
        </span>
    </div>
    <div class="row-margin col-item flex-row">
      <strong class="flex-40 nova__label">Travel Experience Required:</strong>
      <div
        flex
        class="flex-60 capitalize"
        data-qa-id="an_rjd_travelExperienceRequired_readonly"
      >
        <nova-job-qualifications-required-type-change [change]="data.travelExpRequiredTypeId" [noteChange]="data.travelExpNote"></nova-job-qualifications-required-type-change>
      </div>
    </div>


    <div class="row-margin col-item flex-row">
      <div class="flex-40">
        <strong class="nova__label">Certifications:</strong>
        <br />
        <span class="note">Certs marked with * are preferred</span>
      </div>
      <span flex class="flex-60" data-qa-id="an_rjd_certifications_readonly">
        <nova-job-qualifications-certs-change [certs]="data.certifications"></nova-job-qualifications-certs-change>
      </span>
    </div>

    <div class="row-margin col-item flex-row">
      <div class="flex-40">
        <strong class="nova__label">Skills:</strong>
        <br />
        <span class="note">Skills marked with * are preferred</span>
      </div>
      <div flex class="flex-60" data-qa-id="an_rjd_skills_readonly">
        <nova-job-qualifications-skills-change [skills]="data.skills"></nova-job-qualifications-skills-change>
      </div>
    </div>
</div>
</ng-container>
</ng-template>